/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ProhibitedItemUpsertRequestData = {
    jan: string;
    lowestPriceType: ProhibitedItemUpsertRequestData.lowestPriceType;
    deleteFlag?: boolean;
    lowerLimit?: number;
    startDate?: string;
    endDate?: string;
};
export namespace ProhibitedItemUpsertRequestData {
    export enum lowestPriceType {
        EDLP = 'EDLP',
        SARATOKU = 'SARATOKU',
        CHOME = 'CHOME',
        COMPETITOR = 'COMPETITOR',
        FRESHNESS = 'FRESHNESS',
        POS_CHANGED = 'POS_CHANGED',
        ORIGINAL_SELLING_PRICE_CHANGE = 'ORIGINAL_SELLING_PRICE_CHANGE',
        NULL = 'NULL',
        EMPTY = 'EMPTY',
    }
}

